import { Button } from '@dhis2-ui/button';
import PropTypes from 'prop-types';
import React from 'react';
import { IconRemoveAll } from './icons.js';
export const RemoveAll = _ref => {
  let {
    label,
    dataTest,
    disabled,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, {
    dataTest: dataTest,
    disabled: disabled,
    onClick: onClick,
    icon: /*#__PURE__*/React.createElement(IconRemoveAll, {
      disabled: disabled,
      dataTest: "".concat(dataTest, "-iconremoveall")
    })
  }, label);
};
RemoveAll.propTypes = {
  dataTest: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string
};